export const SOC_ICON_SELECTOR = '.icon.soc__icon';

export const DARK_ICON_CLASSNAME = '_dark';
